export const convertToHumanReadable = (anyValue?: string | boolean | null)=>{
  let convertedValue = anyValue;
  if(anyValue === 'True' || anyValue === "true" || anyValue === true) {
    convertedValue='Yes';
  }
  if(anyValue === 'False' || anyValue === "false" || anyValue === false) {
    convertedValue='No';
  }
  if (anyValue === null || anyValue === undefined || anyValue === "" || anyValue === "null") {
    convertedValue = 'Not set';
  }
  return convertedValue;
}